import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../components/Converter";
import Millimetre from "../../../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../components/ToolTip";

function Aussendurchmesser({ aussendurchmesser }) {
  const { t } = useTranslation("translation");
  const D_a_calFormula = `\\displaystyle D_{a,cal} = \\sqrt{ \\frac{4 \\cdot A_{s}}{\\pi} + {D_{i}}^2}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterTragglied.outerDiameter")}</p>}
      formulaValue={
        <ToolTip id={"D_a_calFormula"} type={IconType.FORMULA} formula={D_a_calFormula} />
      }
      indicesValue={
        <span>
          D<sub>a,cal</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(aussendurchmesser, 1)}</span>}
      unitValue={<Millimetre />}
    />
  );
}

export default Aussendurchmesser;
